var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"start-page"},[_c('v-progress-circular',{attrs:{"width":3,"color":"primary","indeterminate":""}}),_c('div',{staticClass:"mt-3 text--secondary"},[_vm._v(" "+_vm._s(_vm.$t("common.app-start"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }